import { EditOutlined } from '@ant-design/icons';
import { Button, Modal, Tooltip } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { GraphQLTaggedNode } from 'react-relay';

import { TableColumnSmxType } from '../types';
import TableEditForm from './TableEditForm';

interface IActionButtonEdit {
    data: any;
    connectionId: string;
    mutationUpdate: GraphQLTaggedNode;
    editableColumns: TableColumnSmxType[];
}

const ActionButtonEdit: React.FC<IActionButtonEdit> = ({ data, connectionId, mutationUpdate, editableColumns }) => {
    const [isOpen, setIsOpen] = useState(false);
    const refButtonForm = useRef<HTMLFormElement>(null);

    useEffect(() => {}, [isOpen]);

    const showModal = () => {
        setIsOpen(true);
    };

    const handleOk = () => {
        console.log('handleOk');
        setIsOpen(false);
        refButtonForm.current?.click();
    };

    const handleCancel = () => {
        setIsOpen(false);
    };

    const handleForm = (isOk: boolean) => {
        console.log(isOk, 'handleForm');
        if (isOk) {
            setIsOpen(false);
        }
    };

    return (
        <>
            <Tooltip title="Edit">
                <Button shape="circle" icon={<EditOutlined />} type={'default'} color="default" onClick={showModal} />
            </Tooltip>
            <Modal
                title={'Edit'}
                open={isOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                okButtonProps={{ size: 'large' }}
                cancelButtonProps={{ size: 'large' }}
                okText={'Save'}
            >
                <TableEditForm
                    handleForm={handleForm}
                    refButton={refButtonForm}
                    data={data}
                    editableColumns={editableColumns}
                    connectionId={connectionId}
                    mutationCreateOrUpdate={mutationUpdate}
                />
            </Modal>
        </>
    );
};

export default ActionButtonEdit;
